import { FaBroadcastTower } from "react-icons/fa";

export function LiveDetectionPage() {
  return (
    <div className="space-y-8">
      <section>
        <h1 className="mb-1 flex items-center gap-2 text-2xl font-semibold text-slate-100">
          Live Detection
          <span className="beta-badge">Beta</span>
        </h1>
        <p className="text-sm text-slate-400">Real-time on-device detection as audio streams in, no upload required.</p>
      </section>

      <div className="rounded-xl border border-slate-800 bg-slate-900/60 px-8 py-14 text-center">
        <FaBroadcastTower className="mx-auto mb-4 text-3xl text-indigo-400" />
        <p className="mb-1 text-base font-medium text-slate-100">This feature is in beta</p>
        <p className="mx-auto max-w-md text-sm text-slate-400">
          Live Detection is still under active development and expected to roll out soon. Check back shortly.
        </p>
      </div>
    </div>
  );
}
